// Real-world release dates (ISO 'YYYY-MM-DD'), independent from the internal
// chronological order in catalog.ts. Used only by the "Release order" tab.
export const RELEASE_DATE: Record<string, string> = {
  ironman1: '2008-05-02',
  hulk: '2008-06-13',
  ironman2: '2010-05-07',
  thor1: '2011-05-06',
  cap1: '2011-07-22',
  avengers1: '2012-05-04',
  ironman3: '2013-05-03',
  thor2: '2013-11-08',
  cap2: '2014-04-04',
  gotg1: '2014-08-01',
  avengers2: '2015-05-01',
  dd_s1: '2015-04-10',
  jj_s1: '2015-11-20',
  antman1: '2015-07-17',
  cap3: '2016-05-06',
  dd_s2: '2016-03-18',
  lc_s1: '2016-09-30',
  spiderman1: '2017-07-07',
  drstrange1: '2016-11-04',
  thor3: '2017-11-03',
  if_s1: '2017-03-17',
  defenders: '2017-08-18',
  pun_s1: '2017-11-17',
  avengers3: '2018-04-27',
  jj_s2: '2018-03-08',
  lc_s2: '2018-06-22',
  if_s2: '2018-09-07',
  dd_s3: '2018-10-19',
  antman2: '2018-07-06',
  pun_s2: '2019-01-18',
  jj_s3: '2019-06-14',
  avengers4: '2019-04-26',
  wandavision: '2021-01-15',
  falcon: '2021-03-19',
  loki1: '2021-06-09',
  whatif1: '2021-08-11',
  farfromhome: '2019-07-02',
  hawkeye: '2021-11-24',
  moonknight: '2022-03-30',
  eternals: '2021-11-05',
  shangchi: '2021-09-03',
  msmarvel: '2022-06-08',
  nowayhome: '2021-12-17',
  drstrange2: '2022-05-06',
  thor4: '2022-07-08',
  shehulk: '2022-08-18',
  wakandaforever: '2022-11-11',
  secretinvasion: '2023-06-21',
  loki2: '2023-10-06',
  whatif2: '2023-12-22',
  quantumania: '2023-02-17',
  gotg3: '2023-05-05',
  marvels: '2023-11-10',
  echo: '2024-01-09',
  'xmen97-1': '2024-03-20',
  xmen1: '2000-07-14',
  x2: '2003-05-02',
  xlaststand: '2006-05-26',
  xorigins: '2009-05-01',
  xfirstclass: '2011-06-03',
  thewolverine: '2013-07-26',
  xdofp: '2014-05-23',
  dp1: '2016-02-12',
  xapocalypse: '2016-05-27',
  logan: '2017-03-03',
  dp2: '2018-05-18',
  darkphoenix: '2019-06-07',
  newmutants: '2020-08-28',
  deadpoolwolverine: '2024-07-26',
  blackwidow: '2021-07-09',
  blackpanther1: '2018-02-16',
  agatha: '2024-09-18',
  whatif3: '2024-12-22',
  yfns1: '2025-01-29',
  bravenewworld: '2025-02-14',
  daredevil1: '2025-03-04',
  thunderbolts: '2025-05-02',
  ironheart: '2025-06-24',
  fantasticfour: '2025-07-25',
  eyesofwakanda: '2025-08-06',
  marvelzombies: '2025-10-03',
  wonderman: '2025-09-10',
  daredevil2: '2026-03-01',
  punisher: '2026-02-01',
  'xmen97-2': '2026-04-01',
  brandnewday: '2026-07-31',
  yfns2: '2027-01-01',
  visionquest: '2026-10-14',
  doomsday: '2026-12-18',
  capmarvel: '2019-03-08',
  gotg2: '2017-05-05',
  daredevil3: '2027-03-01',
  secretwars: '2027-12-17',
  xmenreboot: '2028-05-05',
};

export function releaseYear(id: string): number | null {
  const date = RELEASE_DATE[id];
  return date ? parseInt(date.slice(0, 4), 10) : null;
}
